import React, {Component} from 'react';
import { connect } from 'react-redux';

import classes from './Layout.css';
import Toolbar from '../Navigation/Toolbar/Toolbar';
import SideDrawer from '../Navigation/SideDrawer/SideDrawer';


class Layout extends Component {
    state = {
        showSideDrawer: true
    }

    SideDrawerClosedHandler = () => {
        this.setState({showSideDrawer: false});
    }

    SideDrawerToggleHandler = () => {
        this.setState((prevState) => {
            return {showSideDrawer: !prevState.showSideDrawer}
        })
    }

    render () {
        return (
            <div>
                <Toolbar 
                    isAuth={this.props.isAuthenticated}
                    drawerToggleClicked={this.SideDrawerToggleHandler}/>
                <SideDrawer
                    isAuth={this.props.isAuthenticated}
                    open={this.state.showSideDrawer} 
                    closed={this.SideDrawerClosedHandler}/>
                <main className={classes.Content}>
                    {this.props.children}
                </main>
            </div>
        )
    }
};


const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null
    };
};

// const mapDispatchToProps = dispatch => {
//     return {
//         onFetchedOrders: (token) => dispatch(actions.fetchOrders(token))
//     };
// }

export default connect(mapStateToProps, null)(Layout);


// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js